import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  TextField,
  Switch,
  Typography,
  Modal,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Dialog,
  DialogContent,
  CircularProgress,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import MenuSection from "../components/MenuSection";
import puestos from "../api/puestos";
import pointOfSale from "../api/pointOfSale";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import TagIcon from "@mui/icons-material/Tag";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useNavigate } from "react-router-dom";
import { guardarTalonarios } from "../helpers/guardarTalonariosHelper";
import apiErrorHandler from "../helpers/apiErrorHandler"; // Importa el helper
import CustomSwitch from "../components/CustomSwitch";
import configuracionIntegracionesFULL from "../api/configuracionIntegracionesFULL";
import configuracionIntegraciones from "../api/configuracionIntegraciones";

const ConfiguracionesPage = () => {
  const [modalPuestoOpen, setModalPuestoOpen] = useState(false);
  const [openErrorDialog, setOpenErrorDialog] = useState(false);
  const [errorDialogMessage, setErrorDialogMessage] = useState("");
  const [modalPrefijoOpen, setModalPrefijoOpen] = useState(false);
  const [prefijo, setPrefijo] = useState(
    () => localStorage.getItem("prefijoFront") || "",
  );
  const [qrPosition, setQrPosition] = useState("");
  const [selectedPuestoId, setSelectedPuestoId] = useState("");
  const [getPuestos, setGetPuestos] = useState([]);
  const [openResultDialog, setOpenResultDialog] = useState(false);
  const [validationResult, setValidationResult] = useState({
    success: false,
    message: "",
  });
  const [openSaveDialog, setOpenSaveDialog] = useState(false);
  const [loading, setLoading] = useState(false); // Estado para el indicador de carga
  const [openQrImageModal, setOpenQrImageModal] = useState(false);
  const [qrImageAvailable, setQrImageAvailable] = useState(false);
  const theme = useTheme();
  const navigate = useNavigate();
  const nic = localStorage.getItem("formattedNic");
  const bandera = localStorage.getItem("bandera");
  const [useTips, setUseTips] = useState(
    () => JSON.parse(localStorage.getItem("useTips")) ?? false,
  );
  const [useCashback, setUseCashback] = useState(
    () => JSON.parse(localStorage.getItem("useCashback")) ?? false,
  );
  const integracionMercadoPagoSiteID = localStorage.getItem(
    "integracionMercadoPagoSiteID",
  );
  const [puestoChanged, setPuestoChanged] = useState(false);

  useEffect(() => {
    const fetchLimiteAfip = async () => {
      try {
        const puedeCancelarQR =
          await configuracionIntegraciones.getConfiguracionIntegraciones();
        const habilitarFacturacionArticulosFullPlaya =
          await configuracionIntegracionesFULL.getConfiguracionIntegracionesFULL();
        localStorage.setItem(
          "habilitarFacturacionArticulosFullPlaya",
          habilitarFacturacionArticulosFullPlaya.habilitarFacturacionArticulosFullPlaya,
        );

        localStorage.setItem(
          "puedeCancelarQR",
          JSON.stringify(
            puedeCancelarQR.puedeCancelarTerminalesTarjetasEnCurso,
          ),
        );
        localStorage.setItem(
          "integracionMercadoPagoSiteID",
          puedeCancelarQR.integracionMercadoPagoSiteID,
        );
      } catch (error) {
        console.error("Error al obtener el límite de AFIP:", error);
        apiErrorHandler(error, { stopFlow: true });
      }
    };

    fetchLimiteAfip();
  }, []);

  useEffect(() => {
    localStorage.setItem("useTips", JSON.stringify(useTips));
    localStorage.setItem("useCashback", JSON.stringify(useCashback));
  }, [useTips, useCashback]);

  const handleSelectChangePuesto = async event => {
    const { value } = event.target;
    console.log(value);

    setSelectedPuestoId(value);
    setPuestoChanged(true);
    localStorage.setItem("puesto", JSON.stringify(getPuestos[value]));
    const puesto = JSON.parse(localStorage.getItem("puesto"));
    console.log(puesto);

    const cantidadPlayerosSolicitados = puesto.caja.cantidadPlayerosSolicitados;
    const solicitarAforadores = puesto.caja.solicitarAforadores;
    const perteneceFULL = puesto.talonarios[0].perteneceFULL;
    localStorage.setItem(
      "cantidadPlayerosSolicitados",
      cantidadPlayerosSolicitados,
    );
    localStorage.setItem("solicitarAforadores", solicitarAforadores);
    localStorage.setItem("idCaja", puesto.caja.idCaja);
    localStorage.setItem("perteneceFULL", perteneceFULL);
    localStorage.setItem(
      "combustiblesSoloPorDespachos",
      puesto.combustiblesSoloPorDespachos,
    );
    localStorage.setItem("nombreCaja", puesto.caja.descripcion);
    localStorage.setItem(
      "habilitarCambioListaPrecio",
      puesto.habilitarCambioListaPrecio,
    );
    console.log(
      "Cantidad de Playeros Solicitados:",
      cantidadPlayerosSolicitados,
    );

    const habilitarFacturacionArticulosFullPlaya =
      await configuracionIntegracionesFULL.getConfiguracionIntegracionesFULL();
    localStorage.setItem(
      "habilitarFacturacionArticulosFullPlaya",
      habilitarFacturacionArticulosFullPlaya.habilitarFacturacionArticulosFullPlaya,
    );
    localStorage.setItem(
      "habilitaDespacho",
      solicitarAforadores ||
        habilitarFacturacionArticulosFullPlaya.habilitarFacturacionArticulosFullPlaya,
    );
    const habilitaTiendaFull =
      bandera === "ypf" &&
      (!solicitarAforadores ||
        habilitarFacturacionArticulosFullPlaya.habilitarFacturacionArticulosFullPlaya ||
        perteneceFULL);
    localStorage.setItem("habilitaTiendaFull", habilitaTiendaFull);
    guardarTalonarios(puesto);
  };

  const handleOpenModalPuesto = async () => {
    setModalPuestoOpen(true);
    setLoading(true);
    try {
      const allPuestos = await puestos.getPuestos();
      setGetPuestos(allPuestos);
      localStorage.setItem("puestosArray", JSON.stringify(allPuestos));
      console.log(JSON.stringify(allPuestos));
    } catch (error) {
      console.log("Ocurrió un error al obtener los puestos:", error);
      apiErrorHandler(error, { stopFlow: true });
    } finally {
      setLoading(false);
    }
  };

  const handleContinuarClick = () => {
    setModalPuestoOpen(false);
  };

  const handlePrefijoChange = event => {
    const inputValue = event.target.value;
    if (/^\d*$/.test(inputValue)) {
      setPrefijo(inputValue);
    }
  };

  const handlePrefijoClick = () => {
    if (prefijo) {
      localStorage.setItem("prefijoFront", prefijo);
      setModalPrefijoOpen(false);
      console.log(localStorage.getItem("prefijoFront"));
    }
  };

  const handleQrPositionChange = event => {
    setQrPosition(event.target.value);
  };

  const handleValidateClick = async () => {
    console.log("QR Position:", qrPosition);

    if (!qrPosition) {
      setValidationResult({
        success: false,
        message: "Por favor, ingrese una posición de QR.",
      });
      setOpenResultDialog(true);
      setTimeout(() => setOpenResultDialog(false), 2000);
      return;
    }

    if (
      integracionMercadoPagoSiteID === null ||
      integracionMercadoPagoSiteID === undefined ||
      integracionMercadoPagoSiteID === "" ||
      integracionMercadoPagoSiteID === "undefined"
    ) {
      setValidationResult({
        success: false,
        message:
          "Ha ocurrido un inconveniente técnico en el sistema. Por favor, contacte con la Mesa de Ayuda para continuar. Código de referencia: DLL",
      });
      setOpenResultDialog(true);
      setTimeout(() => setOpenResultDialog(false), 2000);
      return;
    }

    setLoading(true);

    try {
      const response = await pointOfSale.getQR(
        integracionMercadoPagoSiteID,
        qrPosition,
      );

      if (response && response.status === 200) {
        // response.data ya es un Blob porque configuramos responseType: 'blob'
        const reader = new FileReader();
        reader.onload = () => {
          const imageUrl = reader.result;

          // Guardar para uso de la aplicación
          localStorage.setItem("idPosicionQR", qrPosition);
          localStorage.setItem("urlPosicionQR", imageUrl);
          localStorage.setItem("validaQR", "true");

          console.log("QR validated successfully from local API");
          setQrImageAvailable(true);
          setValidationResult({
            success: true,
            message: "El QR fue validado con éxito.",
          });
          setOpenResultDialog(true);
          setTimeout(() => setOpenResultDialog(false), 2000);
        };
        reader.readAsDataURL(response.data); // response.data ya es el Blob
      } else {
        console.log("QR validation failed:", response?.status || "No response");
        localStorage.removeItem("idPosicionQR");
        localStorage.removeItem("urlPosicionQR");
        localStorage.setItem("validaQR", "false");
        setValidationResult({
          success: false,
          message:
            "El QR no pudo ser validado. Por favor, verifique la posición ingresada.",
        });
        setOpenResultDialog(true);
        setTimeout(() => setOpenResultDialog(false), 2000);
      }
    } catch (error) {
      console.error("Error validating QR:", error);
      localStorage.removeItem("idPosicionQR");
      localStorage.removeItem("urlPosicionQR");
      setValidationResult({
        success: false,
        message: "Error de conexión. Por favor, intente nuevamente.",
      });
      setOpenResultDialog(true);
      setTimeout(() => setOpenResultDialog(false), 2000);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setLoading(true);

    // Marcar QR Individual de forma permanente
    localStorage.setItem("conListadoQR", false);

    // Verifica si hay una posición de QR almacenada en localStorage
    const storedQrPosition = localStorage.getItem("idPosicionQR");
    const storedQrImage = localStorage.getItem("urlPosicionQR");
    if (storedQrPosition) {
      setQrPosition(storedQrPosition); // Establece el valor inicial de qrPosition
    }
    if (storedQrImage) {
      setQrImageAvailable(true); // Muestra el icono si ya hay imagen guardada
    }

    setLoading(false);
  }, []);

  const handleGuardar = () => {
    setOpenSaveDialog(true);
    setTimeout(() => {
      setOpenSaveDialog(false);
      navigate(puestoChanged ? "/home" : -1); // Navegar a "/home" después de 2 segundos si puestoChanged es true, de lo contrario navegar hacia atrás
    }, 2000);
  };
  return (
    <>
      <MenuSection />

      {/* Menú con borde */}
      <Box
        sx={{
          mb: 6,
          marginBottom: window.innerWidth < 700 ? 8 : 4,

          p: 2,
          bgcolor: theme.palette.background.paper,
          border: loading ? "none" : "0.5px solid", // Condiciona el borde según el estado de loading
          borderColor: loading ? "transparent" : theme.bandera.colorPrimario, // Asegura que el borde esté transparente cuando loading
          borderRadius: 1,
        }}
      >
        {/* Indicador de carga */}

        <>
          {/* Opciones en columna */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            {/* Opción Seleccionar Puesto */}
            <Button
              variant="contained"
              onClick={handleOpenModalPuesto}
              sx={{
                backgroundColor: theme.bandera.colorSecundario,
                width: "100%",
                justifyContent: "flex-start",
                padding: "12px 24px",
                fontSize: "1.2rem",
                minHeight: "56px",
                ":hover": {
                  backgroundColor: theme.bandera.colorSecundario,
                },
              }}
              startIcon={<AddCircleIcon sx={{ fontSize: "2rem" }} />}
            >
              Seleccionar Puesto
            </Button>

            {/* Opción Ingresar Prefijo */}
            <Button
              variant="contained"
              onClick={() => setModalPrefijoOpen(true)}
              sx={{
                marginTop: 2,
                backgroundColor: theme.bandera.colorSecundario,
                width: "100%",
                justifyContent: "flex-start",
                padding: "12px 24px",
                fontSize: "1.2rem",
                minHeight: "56px",
                ":hover": {
                  backgroundColor: theme.bandera.colorSecundario,
                },
              }}
              startIcon={<TagIcon sx={{ fontSize: "2rem" }} />}
            >
              Ingresar Prefijo
            </Button>
          </Box>
          {/* <Box>
          
            <CustomSwitch
              leftLabel="PROPINA"
              value={useTips}
              onChange={() => setUseTips(prev => !prev)}
            />


            <CustomSwitch
              leftLabel="CASHBACK"
              value={useCashback}
              onChange={() => setUseCashback(prev => !prev)}
            />
          </Box> */}
          {/* Opción con Switch */}
          {(bandera === "ypf" || bandera === "shell") && (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  py: 4,
                }}
              >
                <Typography
                  sx={{
                    fontSize: "18px",
                    fontWeight: "bold",
                    color: theme.bandera.colorPrimario,
                  }}
                >
                  QR INDIVIDUAL
                </Typography>
                {qrImageAvailable && (
                  <VisibilityIcon
                    sx={{
                      ml: 2,
                      color: theme.bandera.colorPrimario,
                      cursor: "pointer",
                      fontSize: "24px",
                      "&:hover": {
                        color: theme.bandera.colorSecundario,
                      },
                    }}
                    onClick={() => setOpenQrImageModal(true)}
                  />
                )}
              </Box>

              <TextField
                variant="outlined"
                placeholder="INGRESE POSICIÓN DE QR"
                value={qrPosition}
                onChange={handleQrPositionChange}
                sx={{ mb: 1, width: "90%" }}
                type="number"
                InputProps={{
                  sx: {
                    fontSize: "17px",
                  },
                  inputProps: {
                    style: { textAlign: "center" },
                  },
                }}
              />
              <Button
                variant="contained"
                color="primary"
                onClick={handleValidateClick}
                disabled={loading}
                sx={{
                  fontSize: "16px",
                  fontWeight: "bold",
                  backgroundColor: theme.bandera.colorSecundario,
                  ":hover": {
                    backgroundColor: theme.bandera.colorSecundario,
                  },
                }}
              >
                {loading ? (
                  <CircularProgress size={24} color="inherit" />
                ) : (
                  "VALIDAR"
                )}
              </Button>
            </Box>
          )}
        </>
      </Box>

      {/* Modal para agregar prefijo */}
      <Modal open={modalPrefijoOpen} onClose={() => setModalPrefijoOpen(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            boxShadow: 24,
            width: "250px",
            p: 4,
            borderRadius: 2,
            display: "grid",
            gridTemplateRows: "auto 1fr",
          }}
        >
          <Typography variant="h6" component="h2" sx={{ mb: 2 }}>
            Ingrese un prefijo
          </Typography>
          <TextField
            type="number"
            value={prefijo}
            onChange={handlePrefijoChange}
            placeholder="Solo números"
            sx={{ height: "1fr" }}
          />
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              mt: 2,
            }}
          >
            <Button
              variant="contained"
              sx={{
                backgroundColor: theme.bandera.colorSecundario,
                ":hover": {
                  backgroundColor: theme.bandera.colorSecundario,
                },
              }}
              onClick={handlePrefijoClick}
              disabled={!prefijo}
            >
              Continuar
            </Button>
          </Box>
        </Box>
      </Modal>

      {/* Modal para seleccionar puesto */}
      <Modal open={modalPuestoOpen} onClose={() => setModalPuestoOpen(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            boxShadow: 24,
            width: "250px",
            p: 4,
            borderRadius: 2,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Typography variant="h6" component="h2" sx={{ mb: 2 }}>
            Puesto de emisión
          </Typography>
          <FormControl fullWidth sx={{ mb: 2 }}>
            <InputLabel id="puesto-select-label">Puestos</InputLabel>
            <Select
              labelId="puesto-select-label"
              id="puesto-select"
              value={selectedPuestoId}
              label="Puestos"
              onChange={handleSelectChangePuesto}
            >
              {getPuestos.map((puesto, index) => (
                <MenuItem key={puesto.nombre} value={index}>
                  {puesto.nombre}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              mt: 2,
            }}
          >
            <Button
              variant="contained"
              sx={{
                backgroundColor: theme.bandera.colorSecundario,
                ":hover": {
                  backgroundColor: theme.bandera.colorSecundario,
                },
              }}
              onClick={handleContinuarClick}
            >
              Continuar
            </Button>
          </Box>
        </Box>
      </Modal>

      {/* Diálogo de resultado */}
      <Dialog
        open={openResultDialog}
        onClose={() => setOpenResultDialog(false)}
      >
        <DialogContent>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            {validationResult.success ? (
              <CheckCircleIcon
                color="success"
                style={{ fontSize: 50, marginRight: "10px" }}
              />
            ) : (
              <ErrorIcon
                color="error"
                style={{ fontSize: 50, marginRight: "10px" }}
              />
            )}
            <Typography fontWeight="bold">
              {validationResult.message}
            </Typography>
          </Box>
        </DialogContent>
      </Dialog>

      {/* Diálogo de guardado */}
      <Dialog open={openSaveDialog} onClose={() => setOpenSaveDialog(false)}>
        <DialogContent>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <CheckCircleIcon
              color="success"
              style={{ fontSize: 50, marginRight: "10px" }}
            />
            <Typography fontWeight="bold">
              Configuraciones guardadas con éxito
            </Typography>
          </Box>
        </DialogContent>
      </Dialog>

      {/* Botón Guardar */}
      <Button
        variant="contained"
        sx={{
          position: "fixed",
          bottom: 45,
          fontWeight: "bold",
          right: 20,
          backgroundColor: theme.bandera.colorSecundario,
          fontSize: "1.2rem",
          padding: "10px 22px",
          ":hover": {
            backgroundColor: theme.bandera.colorSecundario,
          },
        }}
        onClick={handleGuardar}
      >
        GUARDAR
      </Button>
      <Dialog open={openErrorDialog} onClose={() => setOpenErrorDialog(false)}>
        <DialogContent>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <ErrorIcon
              color="error"
              style={{ fontSize: 50, marginRight: "10px" }}
            />
            <Typography fontWeight="bold">{errorDialogMessage}</Typography>
          </Box>
        </DialogContent>
      </Dialog>

      {/* Modal para mostrar imagen QR */}
      <Modal open={openQrImageModal} onClose={() => setOpenQrImageModal(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
            maxWidth: "90vw",
            maxHeight: "90vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Typography
            variant="h6"
            component="h2"
            sx={{ mb: 2, color: theme.bandera.colorPrimario }}
          >
            QR Código - Posición {qrPosition}
          </Typography>
          {localStorage.getItem("urlPosicionQR") && (
            <img
              src={localStorage.getItem("urlPosicionQR")}
              alt="QR Code"
              style={{
                maxWidth: "100%",
                maxHeight: "70vh",
                objectFit: "contain",
              }}
            />
          )}
          <Button
            variant="contained"
            onClick={() => setOpenQrImageModal(false)}
            sx={{
              mt: 2,
              backgroundColor: theme.bandera.colorSecundario,
              "&:hover": {
                backgroundColor: theme.bandera.colorSecundario,
              },
            }}
          >
            Cerrar
          </Button>
        </Box>
      </Modal>
    </>
  );
};

export default ConfiguracionesPage;
